import { range } from '../../utils'
import { MenuOptions, Option } from './Select.types'

export const getCascaderOptionLabel = (data: MenuOptions): string =>
  data.reduce((acc: string, item: Option<string>, itemIndex: number) => {
    if (itemIndex === 0) return item.label

    return acc + ` / ${item.label}`
  }, '')

export const getCascaderOptionValue = (data: MenuOptions): Array<string> =>
  data.map(({ value }) => value)

export const getInitialCascaderMenuOptions = (options: MenuOptions, selectedIds: Array<string>, disabledLevel: number) =>
  selectedIds.reduce((acc, item, itemIndex) => {
    const children = [...options]
		const disabledLevelArr = Array.from({ length: disabledLevel }, () => true);
		const isDisabled = disabledLevelArr?.[itemIndex] ?? false;

    if (itemIndex === 0) {
      const mappingChild = children.map((value) => ({
        ...value,
        isSelected: value.data.value === item,
				isDisabled,
      }))

      acc.push(mappingChild)
      return acc
    }

    //  difficult to reproduce
    // istanbul ignore next
    const selectedValue = acc[itemIndex - 1]?.find(
      (value) => value.data.value === selectedIds[itemIndex - 1],
    )

    //  difficult to reproduce
    // istanbul ignore next
    if (selectedValue.options) {
      acc.push(
        selectedValue.options.map((value) => ({
          ...value,
          isSelected: value.data.value === item,
					isDisabled,
        })),
      )
    }

    return acc
  }, [])

export const parseOptions = (
  acc: MenuOptions,
  item: Option<string>,
  indexPosition: string,
  parentId: string,
) => {
  if (item.options) {
    const { options: items } = item
    const key = `group-${indexPosition}`

    const children = items
      .map((child, index) => parseOptions(acc, child, `${indexPosition}-${index}`, key))
      .filter(Boolean)
    return {
      type: 'group',
      key: key,
      data: item,
      options: children,
      isSelected: false,
      children: item.label,
      parentId,
    }
  } else {
    const option = toOption(item, `${indexPosition}`, parentId)

    return option
  }
}

export const toOption = (option: Option<string>, id: string, parentId?: string) => {
  const isDisabled = !!option.isDisabled
  const isSelected = false
  const label = option.label
  const value = option.value

  const optionId = `option-${id}`

  return {
    data: option,
    isDisabled,
    isSelected,
    key: optionId,
    type: 'option',
    children: label,
    label,
    value,
    parentId,
  }
}
